export default "__VITE_ASSET__CyEoT45C__"